import type { App } from 'vue'

import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import PlusProComponents from 'plus-pro-components'
import 'plus-pro-components/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import plusZhCn from 'plus-pro-components/es/locale/lang/zh-cn'

export const setupElementPlus = (app: App<Element>) => {
  app.use(ElementPlus)
  // 使用
  app.use(PlusProComponents)

  app.use(ElementPlus, {
    locale: { ...zhCn, ...plusZhCn }
  })

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  // 为了开发环境启动更快，一次性引入所有样式
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
    return
  }
}
